import script from "./OldCampaignsQuery.vue?vue&type=script&lang=js"
export * from "./OldCampaignsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__